import React from "react";
import PropTypes from "prop-types";
import "./DocumentMessageContent.scss";

function DocumentMessageContent(props) {
  const { messageSource, message } = props;
  const fileFormat = () => {
    const { fileUrl } = message;
    if (fileUrl && fileUrl.length) {
      const urlAndFormat = fileUrl.split("/");
      const fileName = urlAndFormat[urlAndFormat.length - 1];
      const fileFormat = fileName.split(".")[1];
      if (fileFormat) {
        return fileFormat;
      }
    }
    return "";
  };
  const content = fileFormat()
    ? `${message.message}.${fileFormat()}`
    : message.message;
  return (
    <div
      className={`document-message-content ${messageSource}`}
      data-testid="document-message-content"
    >
      {messageSource === "to" && <div className="attached-file">{content}</div>}
    </div>
  );
}

DocumentMessageContent.propTypes = {
  message: PropTypes.object,
};

export default DocumentMessageContent;
